import { render } from "./EnrollmentsInformation.vue?vue&type=template&id=5dd5d3a2&scoped=true"
import script from "./EnrollmentsInformation.vue?vue&type=script&lang=js"
export * from "./EnrollmentsInformation.vue?vue&type=script&lang=js"

import "./EnrollmentsInformation.vue?vue&type=style&index=0&id=5dd5d3a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd5d3a2"]])

export default __exports__